import { ParticipantTaskSharedService } from '@wealthlane/api-services/wealthlane-award-service';
import { createEntityQuery } from '../../createEntityQuery';
import type { SarAwardAcceptDetailsDto } from './types';

const useSarAwardAcceptDetailsQuery = createEntityQuery<
  SarAwardAcceptDetailsDto,
  { sarAwardId: string }
>({
  queryKey: ['sarAwardAcceptDetails'],
  queryFn: async ({ sarAwardId }) => {
    const result =
      await ParticipantTaskSharedService.getApiAwardApiAppParticipantTaskSarAwardAcceptDetails(
        sarAwardId,
      );
    return result as unknown as SarAwardAcceptDetailsDto;
  },
});

export function useGetSarAwardAcceptDetails(sarAwardId: string, enabled = true) {
  return useSarAwardAcceptDetailsQuery(
    { sarAwardId },
    { enabled: enabled && Boolean(sarAwardId) },
  );
}
